import isIsraeliIdValid from "israeli-id-validator";
import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("שדה חובה")
    .min(2, "הפרטים אינם תקינים, אפשר לנסות שוב.")
    .matches(/^[א-ת\s'"\-]*$/, "יש להזין טקסט בעברית.")
    .max(24, "הפרטים אינם תקינים, אפשר לנסות שוב."),
  lastName: Yup.string()
    .required("שדה חובה")
    .matches(/^[א-ת\s'"\-]*$/, "יש להזין טקסט בעברית.")
    .min(2, "הפרטים אינם תקינים, אפשר לנסות שוב.")
    .max(24, "הפרטים אינם תקינים, אפשר לנסות שוב."),
  phone: Yup.string()
    .required("שדה חובה")
    .min(10, "הפרטים אינם תקינים, אפשר לנסות שוב.")
    .matches(/^[0-9]+$/, "יש להזין מספר בעל 10 ספרות כפי שמעודכן בחברת החשמל")
    .max(10, "הפרטים אינם תקינים, אפשר לנסות שוב."),
  id: Yup.string()
    .required("שדה חובה")
    .min(9, "הפרטים אינם תקינים, אפשר לנסות שוב.")
    .max(9, "הפרטים אינם תקינים, אפשר לנסות שוב.")
    .matches(/^[0-9]+$/, "הפרטים אינם תקינים, אפשר לנסות שוב.")
    .test("personalId", "יש להזין מספר ת.ז חוקי", (value) =>
      isIsraeliIdValid(value)
    )
    .required("יש להזין מספר ת.ז חוקי"),
  email: Yup.string()
    .required("שדה חובה")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "הפרטים אינם תקינים, אפשר לנסות שוב"
    )
    .min(3, "הפרטים אינם תקינים, אפשר לנסות שוב")
    .max(40, "הפרטים אינם תקינים, אפשר לנסות שוב"),
  street: Yup.string()
    //.matches(/^[א-ת'-\s]*$/, "יש להזין טקסט בעברית.")
    .required("אנא הקלד שם רחוב"),
  city: Yup.string()
    //  .matches(/^[א-ת'-\s']*$/, "יש להזין טקסט בעברית.")
    .required("אנא הקלד עיר"),
  houseNumber: Yup.string(),
  agreeToTerms: Yup.boolean().oneOf([true], "שדה חובה"),
});
